import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { deleteStock } from "../../../redux/actions/portfolioActions";
import CircularSpinner from "../../utils/CircularSpinner";

const PortfolioCard = ({stock}) => {
    const [loading, setLoading] = useState(false);
    const userID = useSelector(state => state.user?.user?._id);
    const dispatch = useDispatch();

    const deleteStockFromPortfolio = async (e) => {
        const data = {
            stockID: e.target.id,
            userID: userID
        }
        setLoading(true);
        await dispatch(deleteStock(data));
        setLoading(false);        
    }

    return (
       <div className="col-md-6 col-lg-4">
        <div 
            className='card shadow py-4 px-3  border-1 border rounded-5 
            d-flex flex-column justify-content-between w-100'
            style={{width: "30%", height: "11.5rem"}}>
            <h5>{stock.name}</h5>
            <div>
            <small className="me-3"> <strong>Exchange: </strong> &nbsp; {stock.exchange} </small>
            <small> <strong>Score: </strong> &nbsp; {stock.score} </small>
            </div>
            <div>
            <button className="btn btn-danger btn-sm me-3" 
            onClick={deleteStockFromPortfolio} 
            id={stock._id}
            disabled={loading}>
            {
                loading ? <CircularSpinner /> : <></>
            }
            Delete
            </button>
            <button className="btn btn-success btn-sm">
            <Link to={`/stock/details/${stock.bbFinanceTicker}`} style={{color: "white", textDecoration:"none"}}>
                Explore
            </Link>
            </button>
            </div>
            </div>
       </div>
    )
}

export default PortfolioCard
